import { adminViewTranslations } from './admin/adminView.translations.fr.ts';
import { loginViewTranslation } from './login/loginView.translation.fr.ts';
import { errorsTranslations } from './process/errors/errors.translation.fr.ts';
import { processViewTranslations } from './process/processView.translations.fr.ts';
import { serviceUnavailableTranslation } from './serviceUnavailable/serviceUnavailable.translation.fr.ts';
import { validationTranslation } from './validation/validation.translation.fr.ts';
import type { ViewsTranslations } from './views.translations.pl.ts';

export const viewsTranslations: ViewsTranslations = {
  admin: adminViewTranslations,
  login: loginViewTranslation,
  process: processViewTranslations,
  validation: validationTranslation,
  errors: errorsTranslations,
  serviceUnavailable: serviceUnavailableTranslation,
};
